import styled from '@emotion/styled'

export const OrderDrawerFooterNote = styled.p`
  color: #8c8ca1;
  font-size: 11px;
  margin-bottom: 0;

  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
`
